export const isSuccessFactors = (job: Job): boolean => {
    const successFactorsTitle = "SuccessFactors";
    return job.createdBy === successFactorsTitle
  }